import React, { useState } from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import JobsUsers from "../../constants/JobsUsers";
import JobCard from "./JobCard";
import { pageContentCardSx } from "../../styles/pageModernStyles";

const LEGEND_ITEMS = [
  { key: "noneSigned", color: "#d32f2f" },
  { key: "pending", color: "#f57c00" },
  { key: "allSigned", color: "#2e7d32" },
];

function SignatureLegend({ t, theme }) {
  return (
    <Box
      sx={{
        ...pageContentCardSx(theme, theme.palette.primary.main),
        p: { xs: 1.25, sm: 1.5 },
        mb: 2,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={{ xs: 0.75, sm: 2 }}
        flexWrap="wrap"
        useFlexGap
      >
        {LEGEND_ITEMS.map(({ key, color }) => (
          <Stack key={key} direction="row" alignItems="center" spacing={0.75}>
            <Box
              sx={{
                width: 10,
                height: 10,
                bgcolor: color,
                borderRadius: "50%",
                flexShrink: 0,
              }}
            />
            <Typography variant="caption" fontWeight={600} color="text.secondary">
              {t(`jobDescription.legend.${key}`, {
                defaultValue:
                  key === "noneSigned"
                    ? "Ninguno firmado"
                    : key === "pending"
                      ? "Firmas pendientes"
                      : "Todo firmado | Sin docs",
              })}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

const JobDescription = ({ currentUser, puedeVerTodos }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [openCard, setOpenCard] = useState(null);

  const users = puedeVerTodos
    ? Object.entries(JobsUsers)
    : [[currentUser, JobsUsers[currentUser]]].filter(([, data]) => data);

  return (
    <Box sx={{ mt: 1.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {t("jobDescription.hint", {
          defaultValue:
            "Pulsa un usuario para abrir el panel de documentos y firmar.",
        })}
      </Typography>

      <SignatureLegend t={t} theme={theme} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            lg: "repeat(4, minmax(0, 1fr))",
          },
          gap: { xs: 1.25, sm: 2 },
        }}
      >
        {users.map(([email, { name }]) => (
          <JobCard
            key={email}
            name={name}
            email={email}
            open={openCard === email}
            onOpen={() => setOpenCard(email)}
            onClose={() => setOpenCard(null)}
          />
        ))}
      </Box>

      {users.length === 0 ? (
        <Box
          sx={{
            py: 4,
            textAlign: "center",
            borderRadius: 3,
            border: "1px dashed",
            borderColor: alpha(theme.palette.divider, 0.9),
          }}
        >
          <Typography color="text.secondary" fontWeight={600}>
            {t("jobDescription.noUsers", {
              defaultValue: "No hay documentos asignados para tu usuario.",
            })}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default JobDescription;
